import React from 'react';
import styled from 'styled-components';

import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

import TotalModalWrapper from '../../Share/Normal/TotalModalWrapper';
import { ReactComponent as PinIconSvg } from '../../../image/Pin2.svg';

export default function FixedNoticeLimitModal(props) {
  const { onClickExit } = props;

  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  return (
    <TotalModalWrapper>
      <Modal>
        <TitleWrapper>
          <PinIcon />
          <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.text}>{t('noticePage.fixedLimitTitle')}</Text>
        </TitleWrapper>
        <DescriptionWrapper>
          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text}>{t('noticePage.fixedLimitDesc')}</Text>
        </DescriptionWrapper>
        <Spacer />
        <BackButton onClick={onClickExit}>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text}>{t('noticePage.goBack')}</Text>
        </BackButton>
      </Modal>
    </TotalModalWrapper>
  )
}

const Modal = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  box-sizing: border-box;
  width: 345px;

  padding: 20px;

  gap: 10px;

  border-radius: 10px;
  background-color: ${props => props.theme.subBackground};

  box-shadow: 0px 4px 30px 0px ${props => props.theme.blackAlpha10};
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  gap: 5px;
`;

const PinIcon = styled(PinIconSvg)`
  width: 13px;
  height: 13px;

  flex-shrink: 0;

  & path {
    fill: ${props => props.theme.text};
  }
`;

const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
`;

const Spacer = styled.div`
  width: 100%;
  height: 10px;
`;

const BackButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  box-sizing: border-box;
  width: 100%;
  height: 40px;

  padding: 5px 16px;

  border-radius: 10px;
  background-color: ${props => props.theme.buttonFill};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
`;
